const serviceType = (key) => {
  switch (key) {
    case "CAR":
      return "รถเก๋ง 4 ประตู";
    case "MOTORCYCLE":
      return "มอเตอร์ไซค์";
    case "MPV":
      return "รถ 5 ประตู";
    case "PICK_UP_TRUCK":
      return "รถกระบะ";
    case "4_DOOR_PICKUP_TRUCK":
      return "รถกระบะ 4 ประตู";
    case "SUV":
      return "รถเอสยูวี";
    case "TRUCK175":
      return "รถกระบะโครงเหล็ก";
    case "TRUCK330":
      return "รถกระบะตู้ทึบ";
    default:
      return key;
  }
};

const lalamoveStatus = (key) => {
  switch (key) {
    case "ASSIGNING_DRIVER":
      return "กำลังค้นหาคนขับ";
    case "ON_GOING":
      return "คนขับกำลังเข้าไปรับสินค้า";
    case "PICKED_UP":
      return "คนขับเข้ารับสินค้าแล้ว";
    case "COMPLETED":
      return "ส่งของสำเร็จ";
    case "CANCELED":
      return "ผู้ใช้ยกเลิกรายการ";
    case "REJECTED":
      return "รายการถูกปฎิเสธ";
    case "EXPIRED":
      return "รายการหมดอายุ เนื่องจากไม่มีคนขับรับ";
    default:
      return key;
  }
};

const categoriesText = (key) => {
  switch (key) {
    case "FOOD_AND_BEVERAGE":
      return "อาหาร & เครื่องดื่ม";
    case "HOUSEHOLD_ITEMS_OR_FURNITURE":
      return "ของใช้ในบ้าน / เฟอร์นิเจอร์";
    case "OFFICE_ITEMS_OR_STATIONERIES":
      return "อุปกรณ์สำนักงาน / เครื่องเขียน";
    case "ELECTRONICS":
      return "อุปกรณ์อิเล็กทรอนิกส์";
    case "APPAREL_AND_ACCESSORIES":
      return "เสื้อผ้าและอุปกรณ์เสริม";
    case "FRAGILE_ITEMS":
      return "สินค้าแตกหักง่าย";
    case "OTHERS":
      return "อื่น ๆ";
    default:
      return key;
  }
};

const handlingInstructions = (key) => {
  switch (key) {
    case "FRAGILE_OR_HANDLE_WITH_CARE":
      return "เสียหายง่าย ใช้ความระมัดระวัง";
    case "DO_NOT_STACK":
      return "ห้ามวางซ้อน";
    case "KEEP_DRY":
      return "ห้ามให้ถูกน้ำหรืออยู่ในที่ชื้น";
    case "KEEP_UPRIGHT":
      return "วางแนวตั้งเท่านั้น";
    default:
      return key;
  }
};

const specialRequests = (key) => {
  switch (key) {
    case "CASH_ON_DELIVERY":
      return "บริการเก็บเงินปลายทาง";
    case "CASH_ON_DELIVERY_AUTODEDUCT":
      return "บริการเก็บเงินปลายทาง (หักอัตโนมัติ)";
    case "ROUND_TRIP":
      return "ไป-กลับ";

    case "MOVING_SERVICE":
      return "บริการขนย้ายโดยคนขับ";
    case "MOVING_SERVICE_2":
      return "บริการขนย้ายโดยคนขับและผู้ช่วย 1 คน";
    case "FOOD_DELIVERY":
      return "บริการขนส่งอาหาร";
    case "THERMAL_BAG_1":
      return "กล่องบรรจุอาหาร";

    case "QUEUEING_SERVICE":
      return "ฝากส่งแบบรอคิว (ไปรษณีย์,รถตู้)";
    case "MAILING_SERVICE":
      return "ฝากส่ง (ไปรษณีย์,รถตู้)";
    case "DOCUMENT_HANDLING":
      return "ส่งเอกสารคืน (ในรูปแบบจดหมายลงทะเบียน)";
    case "DOCUMENT_PROCESSING":
      return "ส่งเอกสาร";

    case "DOOR_TO_DOOR_1DRIVER":
      return "บริการยกของโดยคนขับ";
    case "DOOR_TO_DOOR_1DRIVER1HELPER":
      return "บริการยกของโดยคนขับและผู้ช่วย 1 คน";
    case "ADD_ON_TROLLEY":
      return "รถเข็น";

    case "PURCHASE_SERVICE_1":
      return "บริการชำระเงินโดยคนขับ (น้อยกว่า 1,500 บาท)";
    case "PURCHASE_SERVICE_2":
      return "บริการชำระเงินโดยคนขับ (1,500 -3,000 บาท)";
    case "PURCHASE_SERVICE_3":
      return "บริการชำระเงินโดยคนขับ (3,000-4,500 บาท)";
    case "PURCHASE_SERVICE_4":
      return "บริการชำระเงินโดยคนขับ (4,500-6,000 บาท)";

    case "EXTRA_LENGTH":
      return "ยาวพิเศษที่ 2.1 เมตร (มาตรฐาน 1.8 เมตร)";
    case "EXTRA_HEIGHT":
      return "สูงพิเศษที่ 2.1 เมตร (มาตรฐาน 1.7 เมตร)";
    case "EXTRA_CAPACITY":
      return "เพิ่มน้ำหนักไม่เกิน 4 ตัน (ปกติ 1.1 ตัน)";
    case "EXTRA_CAPACITY_W":
      return "หนักพิเศษ 2.9 ตัน";
    case "EXTRA_CAPACITY_H":
      return "สูงพิเศษ 2.1 เมตร";
    case "EXTRA_CAPACITY_L":
      return "ยาวพิเศษ 2.1 เมตร";
    default:
      return key;
  }
};

export {
  serviceType,
  lalamoveStatus,
  categoriesText,
  handlingInstructions,
  specialRequests,
};
